type ModifierKeys = { ctrlKey: boolean; metaKey: boolean; shiftKey: boolean };

// Ctrl/Cmd-click opens the AI Finding popover; with Shift held it is the citation selection instead.
export const isFindingPopoverClick = (event: ModifierKeys) => (event.ctrlKey || event.metaKey) && !event.shiftKey;
